import { render } from "./RestaurantsVue.vue?vue&type=template&id=798a2f6b"
import script from "./RestaurantsVue.vue?vue&type=script&lang=js"
export * from "./RestaurantsVue.vue?vue&type=script&lang=js"

import "./RestaurantsVue.vue?vue&type=style&index=0&id=798a2f6b&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__